/**
 * Ryan O'Dowd
 * 2024-02-12
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import CPassage from '@classes/Passage';
import Passage from '@components/Passage';
import React from 'react';
import {
  View,
} from 'react-native';
import getStyles from './styles';
import hooks from '@hooks';

const VerseMemory = (props: VerseMemoryProps) => {
  const styles = hooks.useStyles(getStyles);

  const minigames = hooks.useTypedSelector((state) => state.minigames);

  return (
    <View style={styles.container}>
      <View style={styles.infoWrapper}>
        <span style={styles.infoText}>Students must {props.must_memorize ? 'memorize' : 'practice'}{!!props.must_memorize && props.num_lessons_to_complete > 0 && ' and practice'} these verses.{!!props.num_lessons_to_complete && <span>{`  At least ${props.num_lessons_to_complete} lesson${props.num_lessons_to_complete > 1 ? 's' : ''} must be completed.`}</span>}</span>
        {!!props.num_lessons_to_complete && <span style={styles.infoText}>Game difficulty: {props.game_difficulty ?? 'student choice'}</span>}{/* @TODO: update difficulty */}
        {!!props.num_lessons_to_complete && <span style={styles.infoText}>Games available: {props.game_types_enabled?.length ? Object.values(minigames).filter((g: any) => props.game_types_enabled.includes(g.id)).map((g: any) => g.name).join(', ') || props.game_types_enabled.join(', ') : 'student choice'}</span>}{/* @TODO: update game types allowed */}
      </View>

      <Passage// @TODO: combine with Reading
        passage={props.passage}
        assignmentId={props.id}
        hideActions={true}
        hideSelectionMenu={true}
        hideWrinkleBadges={true}
        hideProgressStyling={true}
        showHeadings={true}
        isExpanded={false}
        isPressDisabled={true}
        includeTranslationAbbreviation={true}
      />
    </View>
  );
};

class VerseMemoryProps {
  id: number; // @TODO: this is the assignment id, but that's not clear
  passage: CPassage;
  must_memorize: number; // @TODO: should this be a boolean?

  game_difficulty?: 'easy' | 'medium' | 'hard';
  num_lessons_to_complete?: number;
  game_types_enabled?: number[];
};

export default VerseMemory;
